(function ($) {
  // noConflict モード: ここから下では $ で jQuery を使用
  class Top {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0 || $('.js-featureSwiper').length > 0){
        this.event();
      }
    }
    event(){
      this.featureSwiper();
    }
    featureSwiper(){
      const init = () => {
        const el = document.querySelector('.js-featureSwiper');
        if (!el || typeof Swiper === 'undefined' || el.swiper) return;
  
        new Swiper(el, {
          effect: 'cards',
          grabCursor: true,
          rewind: true,
          speed: 1000,
          loop: true,
          autoplay: {
            delay: 2000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
          cardsEffect: {
            perSlideOffset: 0.75,
            perSlideRotate: 5,
            rotate: true,
            slideShadows: false,
          },
        });
      };
  
      $(init);
      $(window).on('load', init);
    }
  }
  
  class Accordion {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      $('.' + this.el).click(function() {
         $(this).next().slideToggle(Number($('html').data('transition')));
         $(this).toggleClass('is-active');
      })
    }
  }
    // 参考サイト
  // https://hacknote.jp/archives/15289/
  
  let cookie = {
  	/**
  	 * 取得
  	 * @param {string} cookieName 取得するCookieの名前
  	 */
  	get : function(cookieName) {
  		if (!navigator.cookieEnabled) return false;
  
  		var getCookieAllData  = document.cookie,
  		    getCookieAllDatas = getCookieAllData.split(';'),
  		    getCookieDatas    = {},
  		    cookieKeyValue    = [],
  		    cookieKey         = '',
  		    cookieValue       = '';
  
  		var hashLength = function(arr) {
  			var result = 0, key = false;
  
  			if (typeof arr !== 'object') return false;
  
  			for (key in arr) result++;
  
  			return result;
  		};
  
  		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
  			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
  				cookieKeyValue = getCookieAllDatas[i].split('=');
  				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
  				cookieValue    = '';
  
  				if (cookieKeyValue[1]) {
  					cookieValue = decodeURIComponent(cookieKeyValue[1]);
  				}
  
  				getCookieDatas[cookieKey] = cookieValue;
  			}
  		}
  
  		if (hashLength(getCookieDatas) > 0) {
  			if (cookieName && cookieName in getCookieDatas) {
  				return getCookieDatas[cookieName];
  			} else {
  				return getCookieDatas;
  			}
  		} else {
  			return '';
  		}
  	},
  
  	/**
  	 * 設定
  	 * @param {string} cookieName 設定するCookieの名前
  	 * @param {string} value 設定する値
  	 * @param {string} domain 有効ドメイン
  	 * @param {string} path 有効パス
  	 * @param {string} expires 有効期限
  	 * @param {boolean} secure セキュアとするか
  	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
  	 */
  	set : function(cookieName, value, domain, path, expires, secure) {
  		if (!navigator.cookieEnabled || !cookieName || !value) return false;
  
  		var date, dt, ts, ts_after;
  
  		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';
  
  		if (domain) setCookieData += 'domain=' + domain + ';';
  
  		if (path) setCookieData += 'path=' + path + ';';
  
  		if (expires) {
        dt = new Date();
        ts = dt.getTime();
  
        // 1時間後
        ts_after = ts + (1000 * 60 * 60 * expires);
  
        date = new Date(ts_after);
  			setCookieData += 'expires=' + date.toGMTString() + ';';
  		}
  
  		if (secure && secure === true && location.protocol.match(/https/)) {
  			setCookieData += 'secure';
  		}
  
  		document.cookie = setCookieData;
  
  		return true;
  	},
  
  	/**
  	 * 削除
  	 * @param {string} cookieName 削除するCookieの名前
  	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
  	 */
  	del : function(cookieName) {
  		if (!navigator.cookieEnabled || !cookieName) return false;
  
  		var getCookieDatas = this.get();
  
  		if (getCookieDatas[cookieName]) {
  			var setCookieData = cookieName + '=;',
  			    date          = new Date(0);
  
  			setCookieData += 'expires=' + date.toGMTString() + '';
  
  			document.cookie = setCookieData;
  
  			return true;
  		}
  
  		return false;
  	}
  };
    class Editor {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      //------- サイドナビ アンカー ---------
      let options = {
        threshold: [0],
        rootMargin: '-49.9%',
      }
      const observerEnter = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const item = entry.target;
          if(entry.intersectionRatio > 0){
            $(`.js-sideNav [href="#${$(item).attr('id')}"]`).siblings().removeClass('is-active')
            $(`.js-sideNav [href="#${$(item).attr('id')}"]`).addClass('is-active')
          } else {
            $(`.js-sideNav [href="#${$(item).attr('id')}"]`).removeClass('is-active')
          }
        })
      }, options)
  
      const anchorEl = document.querySelectorAll('[id*="anchor"]')
      anchorEl.forEach((e)=>{
        observerEnter.observe(e)
      })
  
      
      $('[id*="anchor"]').each(function() {
        let text = $(this).find('.anchorTitle').text();
        let id = $(this).attr('id');
        if(text) {
          let newElement = $(`<a href="#${id}" class="c-transition"><hr class="c-transition">${text}</a>`);
          $('.js-sideNav').append(newElement);
        }
      })
  
      $(".js-sideNav a").click(function() {
        setTimeout(() => {
          $(this).siblings().removeClass('is-active')
          $(this).addClass('is-active')
        }, 600)
      })
  
  
      //------- 〆サイドナビ アンカー ---------
  
      //------- 画像のheught,widthをrem化 ---------
      $('.text-editor img').each(function(index, el) {
        let width = $(el).attr('width')
        // $(el).attr('width')
        $(el).css({'width': `${width * 0.1 + 'rem'}`, 'height': `auto`})
      })
      //------- 画像のheught,widthをrem化 〆 ---------
  
      //------- アコーディオン ---------
      $('.js-editor-accordion .inner').css({'display': 'none'})
  
      $('.js-editor-accordion .trigger').on('click', function() {
        $(this).find('.trigger-icon').toggleClass('is-active')
        $(this).next().slideToggle(Number($('html').data('transition')))
      })
      //------- アコーディオン 〆 ---------
  
      //------- タブ切り替え ---------
      if($(window).innerWidth() >= '769') {
  
        //------- PCの場合 ---------
        $('.js-tab .inner > div > div:nth-of-type(n + 2)').css({'display': 'none'})
        $('.js-tab .trigger .elementor-element:nth-of-type(1)').addClass('is-active')
    
        $('.js-tab .trigger .elementor-element').on('click', function() {
          $(this).siblings().removeClass('is-active')
          $(this).addClass('is-active')
          $(this).closest('.js-tab').find('.inner-child').css({'display': 'none'})
          $(this).closest('.js-tab').find('.inner-child').eq($(this).index()).fadeIn(Number($('html').data('transition')))
        })
        //------- PCの場合 〆 ---------
  
      } else {
  
        //------- SPの場合 ---------
        $('.js-tab').each(function() {
          const _el = $(this)
          const trigger_child = _el.find('.trigger-child')
          _el.find('.inner-child').each(function(index) {
            $(this).before(trigger_child[index])
          })
        })
  
        $('<span></span>').appendTo('.trigger-child > div')
  
        $('.inner-child').css({'display': 'none'})
        $('.trigger-child').click(function() {
          $(this).find('span').toggleClass('is-active')
          $(this).next().slideToggle(Number($('html').data('transition')))
        })
        //------- SPの場合 〆 ---------
        
      }
      //------- タブ切り替え 〆 ---------
    }
  }
    class Follow {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      const $follow = $('.' + this.el);
      const footer = document.querySelector('.js-footer');
      const mq = window.matchMedia('(max-width: 767px)');
      const threshold = 80;
      let footerVisible = false;
  
      const update = () => {
        const shouldShow = mq.matches && window.scrollY > threshold && !footerVisible;
        $follow.toggleClass('is-show', shouldShow);
        $follow.attr('aria-hidden', shouldShow ? 'false' : 'true');
      };
  
      if (footer) {
        const observer = new IntersectionObserver((entries) => {
          footerVisible = entries.some((entry) => entry.isIntersecting);
          update();
        }, {
          threshold: 0
        });
        observer.observe(footer);
      }
  
      $(window).on('scroll', update);
      $(window).on('resize', update);
  
      if (mq.addEventListener) {
        mq.addEventListener('change', update);
      } else if (mq.addListener) {
        mq.addListener(update);
      }
  
      update();
    }
  }
  
    class FormConvert {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      //全角から半角
      function replaceZtoH(str){
        str = str.replace(/[！-～]/g, function(s){
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
        str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
        return str;
      }
      const el = document.querySelector('.js-convert');
      el.addEventListener('blur', () => {
        const br = el.value;
        const ar = replaceZtoH(br);
        el.value = ar;
      });
    }
  }
  
    class Header {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      const $html = $('html');
      const duration = Number($html.data('transition'));
      let scrollLocked = false;
  
      const onTouchMove = (e) => {
        if ($(e.target).closest('.l-header__content').length) return;
        e.preventDefault();
      };
  
      const lockBody = () => {
        if (scrollLocked) return;
        scrollLocked = true;
        scrollBanOpen();
        document.addEventListener('touchmove', onTouchMove, { passive: false });
      };
  
      const unlockBody = () => {
        if (!scrollLocked) return;
        scrollLocked = false;
        scrollBanClose();
        document.removeEventListener('touchmove', onTouchMove);
      };
  
      $('.js-header-trigger').on('click', function(){
        const willOpen = !$html.hasClass('is-header-open');
  
        if (willOpen) {
          lockBody();
          $html.addClass('is-header-open');
          $(this).attr('aria-expanded', 'true');
        } else {
          $html.removeClass('is-header-open');
          $(this).attr('aria-expanded', 'false');
          unlockBody();
          $('.js-header-accordion').attr('aria-expanded', 'false');
          $('.js-header-accordion').closest('.l-header__nav-item').removeClass('is-open');
          $('.l-header__subnav').slideUp(duration);
        }
      });
  
      $('.js-header-accordion').on('click', function(){
        const $item = $(this).closest('.l-header__nav-item');
        const willOpen = !$item.hasClass('is-open');
  
        $item.toggleClass('is-open');
        $(this).attr('aria-expanded', willOpen);
        $item.find('.l-header__subnav').slideToggle(duration);
      });
  
      $('.l-header__nav-link[href^="#"]').on('click', function(e){
        const href = this.getAttribute('href');
        const target = href ? document.querySelector(href) : null;
  
        if (!$html.hasClass('is-header-open') || !target) return;
  
        e.preventDefault();
        $html.removeClass('is-header-open');
        $('.js-header-trigger').attr('aria-expanded', 'false');
        unlockBody();
        $('.js-header-accordion').attr('aria-expanded', 'false');
        $('.js-header-accordion').closest('.l-header__nav-item').removeClass('is-open');
        $('.l-header__subnav').slideUp(duration);
  
        requestAnimationFrame(() => {
          target.scrollIntoView();
          if (history.replaceState) {
            history.replaceState(null, '', href);
          }
        });
      });
    }
  }
  
    // ------------------------------------------
  // imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
  // 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
  // ------------------------------------------
  class ImgParallax {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      let cls = this.el;
      let para_ele = document.querySelectorAll("." + this.el);
      para_ele.forEach((ele, index)=> {
        let property,scrub;
  
        $(ele).css({
          'object-fit':'cover',
          'object-position':'50% 0%',
          'width':'100%',
          'height':'100%',
        })
  
        property = '50% 100%';
        scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;
  
        ele.classList.add(cls + index);
        gsap.to('.' + cls + index, {
          objectPosition: property,
          scrollTrigger: {
            trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
            start: 'top bottom',
            end: 'bottom top',
            scrub: scrub,
            merker: true,
          }
        })
      })
    }
  }
  
    class InviewEvent {
    constructor(el, opt){
      this.el = "." + el;
      this.all = this.el + '-all';
      this.eachUp = this.el + '-each';
      this.eachItem = this.el + '-eachItem';
      this.eachItemFast = this.el + '-eachItem-fast';
      this.eachItemDelay = this.el + '-eachItem-delay';
      if($(this.el).length > 0){
        this.event();
      }
    }
    event() {
      let options = {
        threshold: [0, 0.05, 0.1, 1]
      }
      let optionsAll = {
        threshold: [0, 0.9, 1]
      }
      const observerEnter = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const item = entry.target;
          if(entry.intersectionRatio >= 0.05){
            item.classList.add('is-inview');
            if(item.classList.contains('js-inview-each')){
              this.inviewEachUp(item);
            }
            if(item.classList.contains('js-inview-lottie')){
              this.inviewLottie(item);
            }
            observerEnter.unobserve(item);
          }
        });
      }, options);
      const observerAll = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const item = entry.target;
          if(entry.intersectionRatio >= 0.9){
            item.classList.add('is-inview');
            if(item.classList.contains('js-inview-each')){
              this.inviewEachUp(item);
            }
            observerAll.unobserve(item);
          } else {
            item.classList.remove('is-inview');
          }
        });
      }, optionsAll);
      const inviewItem = document.querySelectorAll(this.el);
      const inviewAllItem = document.querySelectorAll(this.all);
      inviewItem.forEach((e)=>{
        observerEnter.observe(e);
      });
      inviewAllItem.forEach((e)=>{
        observerAll.observe(e);
      });
    }
    inviewEachUp(item){
      $(item).find(this.eachItem).each((i,el)=>{
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: (0.2 * i),
          // y: 0,
          // x: 0,
          onComplete: ()=>{
            $(el).addClass('is-inview');
          }
        });
      });
      $(item).find(this.eachItemFast).each((i,el)=>{
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: (0.1 * i),
          // y: 0,
          // x: 0,
          onComplete: ()=>{
            $(el).addClass('is-inview');
          }
        });
      });
      $(item).find(this.eachItemDelay).each((i,el)=>{
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: (0.5 * i),
          // y: 0,
          // x: 0,
          onComplete: ()=>{
            $(el).addClass('is-inview');
          }
        });
      });
    }
    inviewLottie(item){
      if($(item).hasClass('js-lottie-flow')) {
        lottie.flow();
      }
      if($(item).hasClass('js-lottie-no01')) {
        lottie.no01();
      }
      if($(item).hasClass('js-lottie-no02')) {
        lottie.no02();
      }
      if($(item).hasClass('js-lottie-no03')) {
        lottie.no03();
      }
      if($(item).hasClass('js-lottie-no04')) {
        lottie.no04();
      }
      if($(item).hasClass('js-lottie-no05')) {
        lottie.no05();
      }
      if($(item).hasClass('js-lottie-no06')) {
        lottie.no06();
      }
      if($(item).hasClass('js-lottie-no07')) {
        lottie.no07();
      }
    }
  }
  
    class Modal {
    constructor(el,opt){
      this.el = el;
      this.event();
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      $("." + this.el).on('click', function(e) {
        e.preventDefault();
        $(`[data-id='${$(this).attr('id')}']`).addClass('is-active');
        scrollBanOpen();
      })
  
      $("." + this.el + "-close").on('click', function() {
        $('.js-modal-container').removeClass('is-active');
        scrollBanClase();
      })
    }
  }
    // -------------------------------------------------
  // スクロール禁止
  // -------------------------------------------------
  let scrollTop = 0;
  
  function scrollBanOpen() {
    const html = $('html')[0];
    if (html.classList.contains('is-hidden')) return;
  
    scrollTop = window.scrollY;
    // スクロールバー消失による幅ガタつきを防ぐ
    const gap = window.innerWidth - html.clientWidth;
    html.style.setProperty('--scroll-ban-gap', `${gap}px`);
    html.style.top = (scrollTop * -1) + 'px';
    html.classList.add('is-hidden');
    $('html').css({ 'scroll-behavior': 'inherit' });
  }
  
  function scrollBanClose() {
    const html = $('html')[0];
    if (!html.classList.contains('is-hidden')) return;
  
    html.classList.remove('is-hidden');
    html.style.top = '';
    html.style.removeProperty('--scroll-ban-gap');
    window.scrollTo(0, scrollTop);
    $('html').css({ 'scroll-behavior': 'smooth' });
  }
  
  function scrollBan() {
    if ($('html')[0].classList.contains('is-hidden')) {
      scrollBanClose();
    } else {
      scrollBanOpen();
    }
  }
  
  // 旧関数名の互換（typo含む）
  function scrollBanClase() {
    scrollBanClose();
  }
  
    class TopElementor {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      $('.js-elementor-drawer-trigger').on('click', function(){
        $('html').toggleClass('is-elementor-drawer-open');
        scrollBan();
      });
  
      let scrollTimer;
      $(window).on('scroll', function() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function() {
          if($(window).scrollTop() > 100) {
            $('html').addClass('is-scroll');
          } else {
            $('html').removeClass('is-scroll');
          }
        }, 100);
      });
  
    }
  }
  

  // ページ読み込みが完了したら100%に設定し、しばらく後にバーを消す
  window.addEventListener('load', () => {
    setTimeout(() => {
      $('.js-loading').fadeOut();
    }, 1500);
  });

  (() => {

    let imgParallax = new ImgParallax('js-parallax');
    let inviewEvent = new InviewEvent('js-inview');
    
    // ------------------------------
    // トップページ用
    // ------------------------------
    let top = new Top('p-top');
    
    // ------------------------------
    // ページビルダー用
    // ------------------------------
    let topElementor = new TopElementor('js-topElementor');
    let modal = new Modal('js-modal');
    let accordion = new Accordion('js-accordion');
    let editor = new Editor('c-content');
    let header = new Header('js-header');
    let follow = new Follow('js-follow');

  })();

  //DOMContentLoaded
  $(() => {
  });


  //images resources loaded
  $(window).on('load', () => {

    $(window).trigger('loading');
  });

  //after loading animation
  $(window).on('loading', () => {
  });
})(jQuery);